import React from 'react';

import {replacesTags} from './replaces-tags';
import {ParseResult} from './markdown';

import {markdownPlugins as plugins} from './plugins';

function humanAsterisks(text?: string) {
	if (!text) return;
	return text.replaceAll(/\\\*/g, '*');
}

const HEADING = /^h([1-6])$/;

/**
 * Заголовок внутри текста считается от заголовка, под которым этот текст стоит: у врезки
 * в параграфе h2 заголовок `# …` становится h3. Без опоры (`headingBase`) уровни как написаны.
 */
function headingTag(tag: string, base?: number) {
	const found = base ? tag.match(HEADING) : null;
	if (!found) return tag;
	return `h${Math.min(Number(found[1]) + (base as number), 6)}`;
}

export function treeToNodes(tree: ParseResult[], payload: Record<string, any>) {
	const result: React.ReactElement[] = [];

	tree.forEach((item, index) => {
		const children = item.children ? treeToNodes(item.children, payload) : null;
		const replacesTag = replacesTags[item.tag] || {};
		let tag: any = replacesTag.tag || headingTag(item.tag, payload.headingBase);
		tag = tag === 'TextNode' ? React.Fragment : tag;

		let pluginResult = null;
		if (!children) {
			if (item.content?.includes('{@')) {
				pluginResult = humanAsterisks(item.content)!
					.split(/\{(@.*?)}/)
					.map((part, index) => {
						if (part.startsWith('@')) {
							const command = part.slice(1);
							let args = command.split(', ');
							const first = args.shift()!;
							const [pluginName, firstArgs] = first.split(' ');
							if (firstArgs) args = [firstArgs, ...args];

							if (plugins[pluginName]) {
								const Plugin = plugins[pluginName] as React.FC<{
									payload: Record<string, any>;
									args: string[];
									name: string;
								}>;
								return <Plugin payload={payload} args={args} name={pluginName} key={index} />;
							} else
								return (
									<React.Fragment
										key={index}
									>{`{{Нет плагина для команды ${command}!}}`}</React.Fragment>
								);
						} else {
							return <React.Fragment key={index}>{part}</React.Fragment>;
						}
					});
			}
		}

		const isCustomComponent = typeof tag !== 'string' && tag !== React.Fragment;
		result.push(
			React.createElement(
				tag,
				{key: index, ...item.props, ...replacesTag.props, ...(isCustomComponent ? {payload} : {})},
				children || pluginResult || humanAsterisks(item.content) || undefined,
			),
		);
	});
	return result;
}
